import React from 'react';

interface CashOutTimeLineDateRowProps {
    title?: string;
    amount?: string;
}

export const CashOutTimeLineDateRow: React.FC<CashOutTimeLineDateRowProps> = ({ title = '', amount = '' }) => {
    return (
        <div className='flex items-center justify-between pl-2'>
            <div className='flex flex-row items-center gap-2.5'>
                <span className='text-gray text-caption-2-bold'>{title}</span>
            </div>
            <span className='text-gray text-caption-1-bold'>{amount}</span>
        </div>
    );
};
